/**
 * Shared object for the builder page
 */
let rootObject = null;

export const setRoot = (newRootObject) => rootObject = newRootObject;
export const getRoot = () => rootObject;

